module.exports = __webpack_public_path__ + "static/media/event-detail-gray.f615b876.svg";